var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-prime-cell-image"},[_c('img',{attrs:{"alt":"Изображение","src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }